module.exports = __webpack_public_path__ + "img/career-a1.0f455b6c.jpg";